// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAndDeleteAction_wrapper__CaJSP","deleteButton":"EditAndDeleteAction_deleteButton__qaPam"};